export interface PayerBrokerResponse {
    formParams: {
        key: string,
        value: string
    }[];
}

export interface PayerBrokerV1Response {
    urlRedirect: string;
    token: string;
    jwt: string;
}

export interface PayerBrokerV3Response {
    endpoint: string;
    txtInstCode: string;
    txtProdCode: string;
    txtCurrCode: string;
    txtTranAmt: string;
    txtRefNum: string;
    txtSubNum1: string;
    txtSubNum2: string;
    txtAddCode: string;
    txtMerURL: string;
    MerchantMail: string;
}
